<template>
	<div class="brand-page">
		<div class="brand">
			<div class="canvas-container1">
				<canvas id="arcCanvas1" width="316" height="316"></canvas>
			</div>
			<div class="canvas-container2">
				<canvas id="arcCanvas2" width="316" height="316"></canvas>
			</div>
			<div class="title1">{{ brand.title1 }}</div>
			<div class="title2">{{ brand.title2 }}</div>
			<div class="kg">{{ brand.kg }}</div>
			<div class="co">{{ brand.co }}</div>
			<div class="star">
				<img src="@/assets/tmp/047.png" alt="" v-for="i in brand.star" />
			</div>
			<div class="qrcode">
				<img src="@/assets/tmp/048.png" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
let canvas1 = '';
let ctx1 = '';
let canvas2 = '';
let ctx2 = '';
// 默认参数
let params1 = {
	radius: 128,
	arcAngle: 160,
	fontSize: 20,
	textSpacing: 8,
	textColor: '#ffffff',
	rotation: 0,
	text: 'CARBON FOOTPRINT',
	position: 'right', // 默认位置在上方
	mirror: true, // 默认不开启整体镜像
	charMirror: true // 默认不开启字符镜像
};
let params2 = {
	radius: 117,
	arcAngle: 160,
	fontSize: 18,
	textSpacing: 8,
	textColor: '#ffffff',
	rotation: 0,
	text: 'CCIACFO25110001',
	position: 'left', // 默认位置在上方
	mirror: true, // 默认不开启整体镜像
	charMirror: true // 默认不开启字符镜像
	// text: 'CARBON FOOTPRINT'.split('').reverse().join('')
};
export default {
	components: { Head, Foot },
	data() {
		return {
			brand: {
				title1: '中国集装箱行业',
				title2: '绿色低碳公共服务平台',
				circleText1: 'CARBON FOOTPRINT',
				circleText2: '',
				kg: '110kg',
				co: 'CO2e',
				star: 5,
			}
		};
	},
	created() {},
	mounted() {
		canvas1 = document.getElementById('arcCanvas1');
		ctx1 = canvas1.getContext('2d');
		this.drawArcText1(canvas1, ctx1, params1);
		canvas2 = document.getElementById('arcCanvas2');
		ctx2 = canvas2.getContext('2d');
		this.drawArcText2(canvas2, ctx2, params2);
	},
	methods: {
		drawArcText1(canvas, ctx, params) {
			// 清除画布
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			// 设置文字样式
			ctx.font = `bold ${params.fontSize}px Arial, sans-serif`;
			ctx.fillStyle = params.textColor;
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			// 计算圆弧参数
			const centerX = canvas.width / 2;
			const centerY = canvas.height / 2;
			const startAngle = (Math.PI / 180) * (270 - params.arcAngle / 2 + params.rotation);
			const endAngle = (Math.PI / 180) * (270 + params.arcAngle / 2 + params.rotation);

			// 计算每个字符的角度
			const textLength = params.text.length;
			const totalAngle = endAngle - startAngle;
			const anglePerChar = totalAngle / (textLength - 1 + params.textSpacing);

			// 绘制每个字符
			for (let i = 0; i < textLength; i++) {
				const charAngle = startAngle + anglePerChar * (i + params.textSpacing / 2);
				const x = centerX + params.radius * Math.cos(charAngle);
				const y = centerY + params.radius * Math.sin(charAngle);

				// 保存当前状态
				ctx.save();

				// 移动到字符位置并旋转
				ctx.translate(x, y);
				ctx.rotate(charAngle + Math.PI / 2);

				// 绘制字符
				ctx.fillText(params.text[i], 0, 0);

				// 恢复状态
				ctx.restore();
			}

			// 绘制中心圆点（可选）
			ctx.beginPath();
			ctx.arc(centerX, centerY, 5, 0, Math.PI * 2);
			ctx.fillStyle = 'transparent';
			ctx.fill();
		},
		// 绘制圆弧文字
		drawArcText2(canvas, ctx, params) {
			// 清除画布
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			// 设置文字样式
			ctx.font = `bold ${params.fontSize}px Arial, sans-serif`;
			ctx.fillStyle = params.textColor;
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			// 计算圆弧参数
			const centerX = canvas.width / 2;
			const centerY = canvas.height / 2;

			// 根据位置设置起始角度
			let startAngle, endAngle;
			switch (params.position) {
				case 'top':
					startAngle = Math.PI + (Math.PI / 180) * (params.arcAngle / 2 + params.rotation);
					endAngle = Math.PI - (Math.PI / 180) * (params.arcAngle / 2 - params.rotation);
					break;
				case 'bottom':
					startAngle = 0 + (Math.PI / 180) * (params.arcAngle / 2 + params.rotation);
					endAngle = 0 - (Math.PI / 180) * (params.arcAngle / 2 - params.rotation);
					break;
				case 'left':
					startAngle = Math.PI / 2 + (Math.PI / 180) * (params.arcAngle / 2 + params.rotation);
					endAngle = Math.PI / 2 - (Math.PI / 180) * (params.arcAngle / 2 - params.rotation);
					break;
				case 'right':
					startAngle = (3 * Math.PI) / 2 + (Math.PI / 180) * (params.arcAngle / 2 + params.rotation);
					endAngle = (3 * Math.PI) / 2 - (Math.PI / 180) * (params.arcAngle / 2 - params.rotation);
					break;
			}

			// 计算每个字符的角度
			const textLength = params.text.length;
			const totalAngle = endAngle - startAngle;
			const anglePerChar = totalAngle / (textLength - 1 + params.textSpacing);

			// 绘制每个字符
			for (let i = 0; i < textLength; i++) {
				const charAngle = startAngle + anglePerChar * (i + params.textSpacing / 2);
				const x = centerX + params.radius * Math.cos(charAngle);
				const y = centerY + params.radius * Math.sin(charAngle);

				// 保存当前状态
				ctx.save();

				// 移动到字符位置
				ctx.translate(x, y);

				// 应用整体镜像效果
				if (params.mirror) {
					// 根据位置应用不同的镜像变换
					switch (params.position) {
						case 'top':
							// 上方位置 - 垂直镜像 + 旋转调整
							ctx.scale(1, -1);
							ctx.rotate(-charAngle - Math.PI / 2);
							break;
						case 'bottom':
							// 下方位置 - 垂直镜像 + 旋转调整
							ctx.scale(1, -1);
							ctx.rotate(-charAngle - Math.PI / 2);
							break;
						case 'left':
							// 左侧位置 - 水平镜像 + 旋转调整
							ctx.scale(-1, 1);
							ctx.rotate(-charAngle - Math.PI / 2);
							break;
						case 'right':
							// 右侧位置 - 水平镜像 + 旋转调整
							ctx.scale(-1, 1);
							ctx.rotate(-charAngle - Math.PI / 2);
							break;
					}
				} else {
					// 正常显示 - 只旋转不镜像
					ctx.rotate(charAngle + Math.PI / 2);
				}

				// 应用字符级镜像效果
				if (params.charMirror) {
					// 每个字符本身进行上下镜像
					ctx.scale(1, -1);
				}

				// 绘制字符
				ctx.fillText(params.text[i], 0, 0);

				// 恢复状态
				ctx.restore();
			}

			// 绘制中心圆点（可选）
			ctx.beginPath();
			ctx.arc(centerX, centerY, 5, 0, Math.PI * 2);
			ctx.fillStyle = 'transparent';
			ctx.fill();
		}
	}
};
</script>

<style lang="scss" scoped>
.brand-page {
	.brand {
		width: 316px;
		height: 520px;
		background-image: url('~@/assets/tmp/049.png');
		background-size: 100% 100%;
		position: relative;
		.canvas-container1 {
			position: absolute;
			top: 0;
			left: 0;
		}
		.canvas-container2 {
			position: absolute;
			top: 0;
			left: 0;
		}
		.title1 {
			position: absolute;
			top: 370px;
			right: 165px;
			font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
			font-weight: normal;
			font-size: 20px;
			color: #ffffff;
			line-height: 30px;
			letter-spacing: 1px;
			transform: translateX(50%);
		}
		.title2 {
			position: absolute;
			top: 400px;
			right: 165px;
			font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
			font-weight: normal;
			font-size: 20px;
			color: #ffffff;
			line-height: 30px;
			letter-spacing: 1px;
			transform: translateX(50%);
			white-space: nowrap;
		}
		.kg {
			position: absolute;
			top: 110px;
			right: 70px;
			font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
			font-weight: normal;
			font-size: 13px;
			color: #ffffff;
			line-height: 18px;
			transform: translateX(-50%);
		}
		.co {
			position: absolute;
			top: 130px;
			right: 70px;
			font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
			font-weight: normal;
			font-size: 13px;
			color: #ffffff;
			line-height: 18px;
			transform: translateX(-50%);
		}
		.star {
			position: absolute;
			top: 190px;
			left: 115px;
			font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
			font-weight: normal;
			font-size: 28px;
			color: #ffffff;
			line-height: 45px;
			transform: translateX(-50%) rotate(36deg);
			display: flex;
			img {
				width: 12px;
				height: 12px;
			}
		}
		.qrcode {
			position: absolute;
			top: 190px;
			right: 70px;
			font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
			font-weight: normal;
			font-size: 28px;
			color: #ffffff;
			line-height: 45px;
			transform: translateX(-50%);
			display: flex;
			img {
				width: 30px;
				height: 30px;
			}
		}
	}
}
</style>
